/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, useState, useEffect, Fragment} from 'react'
import {useIntl} from 'react-intl'
import Table from 'react-bootstrap/Table'
import Button from 'react-bootstrap/Button'
import {PageTitle} from '../../../../../_metronic/layout/core'
import Form from 'react-bootstrap/Form'
import {Col, Dropdown, Row, Spinner} from 'react-bootstrap'
import Pagination from 'react-bootstrap/Pagination'
import usePagination from 'utils/hooks/usePagination'
import {useNavigate} from 'react-router-dom'
import JobServices from '../../../../../services/job'
import useServices from '../../../../../utils/hooks/useServices'
import useDebounce from '../../../../../utils/hooks/useDebounce'

let active = 1
let items: any = []
for (let number = 1; number <= 5; number++) {
  items.push(
    <Pagination.Item key={number} active={number === active}>
      {number}
    </Pagination.Item>
  )
}

const heads = [
  {
    name: '',
    label: 'Judul',
  },
  {
    name: '',
    label: 'Nama Perusahaan',
  },
  {
    name: '',
    label: 'Tanggal Melamar',
  },
  {
    name: '',
    label: 'Status',
  },
  {
    name: '',
    label: 'Aksi',
  },
]

const status = [
  {
    name: 'Menunggu Konfirmasi',
  },
  {
    name: 'Aktif',
  },
  {
    name: 'Ditolak',
  },
  {
    name: 'Non Aktif',
  },
]

const StatusComponent = (statusNumber: any) => {
  if (statusNumber == 3) {
    return <Button className='shadow-none btn-sm btn-outline btn-outline-danger'>Rejected</Button>
  }
  if (statusNumber == 2) {
    return <Button className='shadow-none btn-sm btn-outline btn-outline-success'>Recruited</Button>
  }

  return (
    <Button className='shadow-none btn-sm btn-outline btn-outline-primary'>
      {statusNumber == '1' ? 'In Process' : 'Applied'}
    </Button>
  )
}

const JobsPage: FC = () => {
  let navigate = useNavigate()
  const [pagination, setPagination] = useState({
    per_page: 10,
    page: 1,
    total_page: 1,
    total_page_arr: [1, 2, 3, 4, 5],
    total_row: 10,
  })
  const [query, setQuery] = useState<any>({q: '', sort_order: 'desc'})
  const [jobs, loadingJobs, makeJobsEmpty, refreshJobs] = useServices(
    JobServices.jobApplyHash,
    {...query, sort_field: 'created_at', page: pagination.page, per_page: pagination.per_page},
    []
  )

  useEffect(() => {
    refreshJobs()
    generateTotalPage(pagination.total_page)
  }, [pagination.per_page, pagination.page])

  useDebounce(refreshJobs, 250, [query])

  const generateTotalPage = (totalPage: number) => {
    let total = 0
    let newTotal: any = []

    for (total = 0; total < totalPage; total++) {
      newTotal.push(total + 1)
    }

    // setPagination({
    //   ...pagination,
    //   total_page_arr: newTotal,
    // })
    return newTotal
  }

  const onChangePerPage = (per_page: number, to_page = 1) => {
    setPagination({
      ...pagination,
      per_page: per_page,
      page: to_page || 1,
    })
  }

  return (
    <>
      <div className='row'>
        <div className='col-md-12'>
          <div className='card-custom'>
            <Row>
              <Col md={{span: 4}}>
                <Form.Control
                  placeholder='Cari...'
                  name='q'
                  onChange={(e) => setQuery({...query, q: e.target.value})}
                />
              </Col>
              <Col md={{span: 2, offset: 6}}>
                <Form.Select
                  aria-label='Default select example'
                  className='mr-8'
                  onChange={(e) => {
                    setQuery({...query, sort_order: e.target.value})
                  }}
                >
                  <option value='desc'>Terbaru</option>
                  <option value='asc'>Terlama</option>
                </Form.Select>
              </Col>
            </Row>
            <Table responsive className='mt-4'>
              <thead>
                <tr>
                  <th style={{fontWeight: 'bold', textTransform: 'uppercase'}}>#</th>
                  {heads.map((item, index) => (
                    <th key={index} style={{fontWeight: 'bold', textTransform: 'uppercase'}}>
                      {item.label}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {jobs.data?.data?.length === 0 && !loadingJobs && (
                  <tr>
                    <td colSpan={6} align='center'>
                      Tidak ada Data
                    </td>
                  </tr>
                )}
                {loadingJobs ? (
                  <tr>
                    <td colSpan={6} align='center'>
                      <Spinner
                        animation='border'
                        role='status'
                        style={{height: '100px', width: '100px'}}
                      />
                    </td>
                  </tr>
                ) : (
                  jobs.data?.data?.map((item: any, key: any) => {
                    const date = new Date(item.created_at)
                    const finalDate = `${date.toLocaleString()}`
                    return (
                      <tr key={key}>
                        <td>{key + 1}</td>
                        <td>
                          <a
                            href='#!'
                            onClick={() =>
                              navigate(`/job-search/${item?.company_job?.company_jobs_id}`)
                            }
                          >
                            {item.company_job?.company_jobs_title}
                          </a>
                        </td>
                        <td>{item.company_job?.company?.companies_name}</td>
                        <td>{finalDate}</td>
                        <td>{StatusComponent(item?.status)}</td>
                        <td>
                          <Dropdown>
                            <Dropdown.Toggle id='dropdown-basic' className='btn btn-primary btn-sm'>
                              {'  '}
                              Aksi
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                              <Dropdown.Item
                                onClick={() =>
                                  navigate(`/job-search/${item?.company_job?.company_jobs_id}`)
                                }
                              >
                                Lihat
                              </Dropdown.Item>
                            </Dropdown.Menu>
                          </Dropdown>
                        </td>
                      </tr>
                    )
                  })
                )}
              </tbody>
            </Table>
            {jobs?.data?.data?.length > 0 && (
              <Fragment>
                <div>
                  <Dropdown>
                    <Dropdown.Toggle>{pagination.per_page}</Dropdown.Toggle>
                    <Dropdown.Menu>
                      <Dropdown.Item
                        href='#/action-1'
                        onClick={() => onChangePerPage(10)}
                        disabled={pagination.per_page === 10}
                      >
                        10
                      </Dropdown.Item>
                      <Dropdown.Item
                        href='#/action-1'
                        onClick={() => onChangePerPage(25)}
                        disabled={pagination.per_page === 25}
                      >
                        25
                      </Dropdown.Item>
                      <Dropdown.Item
                        href='#/action-2'
                        onClick={() => onChangePerPage(50)}
                        disabled={pagination.per_page === 50}
                      >
                        50
                      </Dropdown.Item>
                      <Dropdown.Item
                        href='#/action-3'
                        onClick={() => onChangePerPage(100)}
                        disabled={pagination.per_page === 100}
                      >
                        100
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
                <div style={{float: 'right'}}>
                  <Pagination>
                    {generateTotalPage(jobs?.data?.last_page)?.map((item: any) => {
                      return (
                        <Pagination.Item
                          key={item}
                          active={item === pagination.page}
                          onClick={() => onChangePerPage(pagination.per_page, item)}
                        >
                          {item}
                        </Pagination.Item>
                      )
                    })}
                  </Pagination>
                </div>
              </Fragment>
            )}
          </div>
        </div>
      </div>
    </>
  )
}

const MyApplicant: FC = () => {
  const intl = useIntl()
  return (
    <>
      <PageTitle
        breadcrumbs={[
          {
            title: 'Dashboard',
            path: '/dashboard',
            isSeparator: false,
            isActive: false,
          },
          {
            title: '/',
            path: '',
            isSeparator: false,
            isActive: false,
          },
        ]}
      >
        Lamaran Saya
      </PageTitle>
      <JobsPage />
    </>
  )
}

export default MyApplicant
